import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import configuration from 'assets/configuration.json';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate, CanActivateChild {
    constructor(private _router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        return this._check(route);
    }

    canActivateChild(route: ActivatedRouteSnapshot): boolean | UrlTree {
        return this._check(route);
    }

    private _check(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const featureFlag = route.data?.featureFlag as string;
        if (!featureFlag || !configuration[featureFlag]) {
            return true;
        }

        const loggedInUser = JSON.parse(
            localStorage.getItem('loggedInUser') || '{}',
        );
        const orgId = loggedInUser.org_id;
        const flagConfig = configuration[featureFlag];
        const enabled = flagConfig[orgId] ?? flagConfig['default'];

        if (enabled) {
            return true;
        }

        return this._router.parseUrl('/dashboard');
    }
}
